"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactKonva = require("react-konva");

var _leftLine = _interopRequireDefault(require("./grid-borders/left-line.component"));

var _topLine = _interopRequireDefault(require("./grid-borders/top-line.component"));

var _horizontalLines = _interopRequireDefault(require("./grid-lines/horizontal-lines.component"));

var _verticalLines = _interopRequireDefault(require("./grid-lines/vertical-lines.component"));

var _rectangle = _interopRequireDefault(require("./grid-rect/rectangle.component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Grid = function Grid(_ref) {
  var shapeProps = _ref.shapeProps,
      isSelected = _ref.isSelected,
      warningInfo = _ref.warningInfo,
      lineSelectedId = _ref.lineSelectedId,
      columnIndex = _ref.columnIndex,
      rowIndex = _ref.rowIndex,
      moveAllLinesMode = _ref.moveAllLinesMode,
      lineClick = _ref.lineClick,
      rectClick = _ref.rectClick,
      onChangeRect = _ref.onChangeRect,
      onChangeVLines = _ref.onChangeVLines,
      onChangeHLines = _ref.onChangeHLines,
      onChangeRectEnd = _ref.onChangeRectEnd,
      onChangeTransformEnd = _ref.onChangeTransformEnd,
      onChangeVLinesEnd = _ref.onChangeVLinesEnd,
      onChangeHLinesEnd = _ref.onChangeHLinesEnd,
      onAddVLines = _ref.onAddVLines,
      onAddHLines = _ref.onAddHLines,
      setColumnIndex = _ref.setColumnIndex,
      setRowIndex = _ref.setRowIndex,
      tooltipClickAction = _ref.tooltipClickAction,
      onSelectObject = _ref.onSelectObject,
      isSideNavBarInfoOpen = _ref.isSideNavBarInfoOpen;
  var rectRef = (0, _react.useRef)();
  var trRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      initWarning = _useState2[0],
      setInitWarning = _useState2[1];
  /**
   * Adds new vertical line
   * @param {event} e
   */


  var addVLine = function addVLine(e) {
    var newLineIndex = columnIndex + 1;
    setColumnIndex(newLineIndex);
    var newVLine = {
      x: e.evt.offsetX,
      xRectDist: e.evt.offsetX - shapeProps.rect.x,
      id: "vLine".concat(newLineIndex).concat(shapeProps.rect.id)
    };
    var columnLocation = shapeProps.vLines.filter(function (vLine) {
      return vLine["xRectDist"] < newVLine["xRectDist"];
    }).length;
    onAddVLines([].concat(_toConsumableArray(shapeProps.vLines), [newVLine]), {
      columnLocation: columnLocation,
      id: "vLine".concat(newLineIndex).concat(shapeProps.rect.id)
    });
  };
  /**
   * Adds new horizontal line
   * @param {event} e
   */


  var addHLine = function addHLine(e) {
    var newLineIndex = rowIndex + 1;
    setRowIndex(newLineIndex);
    var newHLine = {
      y: e.evt.offsetY,
      yRectDist: e.evt.offsetY - shapeProps.rect.y,
      id: "hLine".concat(newLineIndex).concat(shapeProps.rect.id)
    };
    onAddHLines([].concat(_toConsumableArray(shapeProps.hLines), [newHLine]));
  };
  /**
   * Updates vLines after checking that the line is not out of bounds
   * @param {array} updatedVLines
   */


  var updateVLines = function updateVLines(updatedVLines) {
    var newVLines = updatedVLines.filter(function (vLine) {
      if (vLine.xRectDist < 0 || vLine.xRectDist > shapeProps.rect.width) {
        return false;
      } else {
        return true;
      }
    });
    onChangeVLines(newVLines);
  };
  /**
   * Updates vLines after checking that the line is not out of bounds
   * @param {array} updatedVLines
   */


  var updateVLinesEnd = function updateVLinesEnd(updatedVLines) {
    var newVLines = updatedVLines.filter(function (vLine) {
      if (vLine.xRectDist < 0 || vLine.xRectDist > shapeProps.rect.width) {
        return false;
      } else {
        return true;
      }
    });
    onChangeVLinesEnd(newVLines);
  };
  /**
   * Updates hLines after checking that the line is not out of bounds
   * @param {array} updatedHLines
   */


  var updateHLines = function updateHLines(updatedHLines) {
    var newHLines = updatedHLines.filter(function (hLine) {
      if (hLine.yRectDist < 0 || hLine.yRectDist > shapeProps.rect.height) {
        return false;
      } else {
        return true;
      }
    });
    onChangeHLines(newHLines);
  };
  /**
   * Updates hLines after checking that the line is not out of bounds
   * @param {array} updatedHLines
   */


  var updateHLinesEnd = function updateHLinesEnd(updatedHLines) {
    var newHLines = updatedHLines.filter(function (hLine) {
      if (hLine.yRectDist < 0 || hLine.yRectDist > shapeProps.rect.height) {
        return false;
      } else {
        return true;
      }
    });
    onChangeHLinesEnd(newHLines);
  };

  (0, _react.useEffect)(function () {
    /**
     * Attaches the rectangle ref to the Transformer ref
     */
    var attachRect = function attachRect() {
      if (isSelected) {
        trRef.current.nodes([rectRef.current]);
        trRef.current.getLayer().batchDraw();
      }
    };

    attachRect();
  }, [isSelected]);
  (0, _react.useEffect)(function () {
    if (shapeProps.hasOwnProperty("warning")) {
      setInitWarning(shapeProps["warning"]);
    }
  }, [shapeProps]);
  return /*#__PURE__*/_react.default.createElement(_reactKonva.Group, {
    onMouseDown: function onMouseDown(e) {
      if (isSelected || lineSelectedId !== null && lineSelectedId.includes(shapeProps.rect.id)) {
        e.evt.stopPropagation();
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_rectangle.default, {
    rectRef: rectRef,
    rectProps: shapeProps.rect,
    isSelected: isSelected,
    warningInfo: warningInfo,
    initWarning: initWarning,
    moveAllLinesMode: moveAllLinesMode,
    vLines: shapeProps.vLines,
    hLines: shapeProps.hLines,
    rectClick: rectClick,
    updateVLines: updateVLines,
    updateHLines: updateHLines,
    onChangeRect: onChangeRect,
    onChangeRectEnd: onChangeRectEnd,
    onChangeTransformEnd: onChangeTransformEnd,
    tooltipClickAction: tooltipClickAction,
    onSelectObject: onSelectObject,
    isSideNavBarInfoOpen: isSideNavBarInfoOpen
  }), /*#__PURE__*/_react.default.createElement(_leftLine.default, {
    rectHeight: shapeProps.rect.height,
    rectLocationX: shapeProps.rect.x,
    rectLocationY: shapeProps.rect.y,
    warningInfo: warningInfo,
    initWarning: initWarning,
    addHorizontalLine: addHLine
  }), /*#__PURE__*/_react.default.createElement(_topLine.default, {
    rectWidth: shapeProps.rect.width,
    rectLocationX: shapeProps.rect.x,
    rectLocationY: shapeProps.rect.y,
    warningInfo: warningInfo,
    initWarning: initWarning,
    addVerticalLine: addVLine
  }), isSelected && /*#__PURE__*/_react.default.createElement(_reactKonva.Transformer, {
    ignoreStroke: true,
    ref: trRef,
    boundBoxFunc: function boundBoxFunc(oldBox, newBox) {
      // limit resize and prevents box from becoming
      //  "negative" in size
      if (newBox.width < 5 || newBox.height < 5) {
        return oldBox;
      }

      return newBox;
    },
    rotateEnabled: false,
    borderEnabled: false,
    keepRatio: false,
    enabledAnchors: ["top-left", "top-right", "bottom-left", "bottom-right"]
  }), /*#__PURE__*/_react.default.createElement(_verticalLines.default, {
    rectProps: shapeProps.rect,
    warningInfo: warningInfo,
    initWarning: initWarning,
    lineSelectedId: lineSelectedId,
    vLines: shapeProps.vLines,
    updateVLinesEnd: updateVLinesEnd,
    lineClick: lineClick
  }), /*#__PURE__*/_react.default.createElement(_horizontalLines.default, {
    rectProps: shapeProps.rect,
    warningInfo: warningInfo,
    initWarning: initWarning,
    lineSelectedId: lineSelectedId,
    hLines: shapeProps.hLines,
    updateHLinesEnd: updateHLinesEnd,
    lineClick: lineClick
  }));
};

var _default = Grid;
exports.default = _default;